import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";


import tickIcon from "../../../assets/img/icons/tick-green.svg";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import RightSlidingPanel from "../../../components/RightSlidingPanel/RightSlidingPanel";
import SearchWithButton from "../../../components/Search/SearchWithButton";
import {
  PrimaryButton,
  PrimaryWhiteBgButton,
} from "../../../styledComponents/buttons";
import {
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
} from "../../../styledComponents/common";
import { CommImageNameComp } from "../../Members/CommonComponents";
import { ReinviteButton } from "../Setup/integrationSetupStyles";

const highlightText = (text, searchTerm) => {
  if (!searchTerm.trim()) return text;

  const parts = text.split(new RegExp(`(${searchTerm.trim()})`, "gi"));
  return parts.map((part, index) =>
    part.toLowerCase() === searchTerm.trim().toLowerCase() ? (
      <strong key={index}>{part}</strong>
    ) : (
      part
    ),
  );
};

const getFilteredItems = (items, searchTerm) => {
  if (!searchTerm.trim()) return items;

  const search = searchTerm.toLowerCase();
  return items.filter(item => {
    const fullName = `${item.first_name} ${item.last_name || ""}`.toLowerCase();
    const email = item.email.toLowerCase();
    return fullName.includes(search) || email.includes(search);
  });
};

const MemberRightSidePanel = ({
  isOpen,
  toggle,
  isLoading,
  listItems,
  handleClick,
  memberInvitedList,
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  const onSearchTermChange = e => {
    const { value } = e.target;
    setSearchTerm(value);
  };

  const handleSearchByName = () => {
    // Filter is applied automatically via useMemo
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const isEmailInvited = email => {
    return memberInvitedList?.some(
      invited => invited.email.toLowerCase() === email.toLowerCase(),
    );
  };

  const filteredItems = useMemo(
    () => getFilteredItems(listItems || [], searchTerm),
    [listItems, searchTerm],
  );
  return (
    <RightSlidingPanel
      isOpen={isOpen}
      closePanel={() => toggle()}
      width="540px"
      overlayZIndex={2}
      contentZIndex={2}
    >
      {isLoading && <ComponentCircleLoader />}

      <Container padding="32px 20px" gap="16px" marginTop="0">
        <CommonGrid gap="16px">
          <CommonText name bold fontSize="18px">
            {t("employee")} {`(${filteredItems?.length})`}
          </CommonText>
          <PrimaryButton onClick={() => handleClick(listItems)}>
            Invite All
          </PrimaryButton>
        </CommonGrid>
        <SearchWithButton
          noLabel
          itemName={t("task")}
          searchTermName={t("task_name")}
          searchInput={searchTerm}
          onInputChange={onSearchTermChange}
          handleSearch={handleSearchByName}
          handleClearSearch={handleClearSearch}
        />
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          filteredItems?.map((item, index) => {
            const fullName = `${item.first_name} ${item.last_name || ""}`;
            const isInvited = isEmailInvited(item.email);
            return (
              <CommonGrid key={index} gap="12px">
                <div>
                  <CommonText fontWeight="600" color="#000E2A">
                    {highlightText(fullName, searchTerm)}
                  </CommonText>
                  <CommonText fontSize="12px" color="#353A46">
                    {highlightText(item.email, searchTerm)}
                  </CommonText>
                </div>
                {isInvited ? (
                  <CommonGrid alignItem="center">
                    <CommonImage
                      src={tickIcon}
                      alt="Invited"
                      width="16px"
                      height="16px"
                    />
                    <ReinviteButton onClick={() => handleClick([item])}>
                      Reinvite
                    </ReinviteButton>
                  </CommonGrid>
                ) : (
                  <PrimaryWhiteBgButton onClick={() => handleClick([item])}>
                    Invite
                  </PrimaryWhiteBgButton>
                )}
              </CommonGrid>
            );
          })
        )}
      </Container>
    </RightSlidingPanel>
  );
};

export default MemberRightSidePanel;
